import React, { Component } from "react";
import { Row, Col, Card, Typography, notification, Tag, Divider, Select, Table } from "antd";
import moment from "moment";
import ModalItem from "../../../../Components/ModalItem";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import {
  ButtonItem,
  InputNumberItem,
  SwitchItem,
  TextAreaItem,
  CheckItem,
  SelectItem,
} from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";

const { Title, Text } = Typography;

const claveRespuesta = (seccionIndex, preguntaIndex) => `${seccionIndex}-${preguntaIndex}`;

class ModalLlenarEvaluacion extends Component {
  state = {
    loading: false,
    guardando: false,
    completando: false,
    evaluacion: null,
    respuestas: {}, // clave -> {noAplica, valorTexto, valorNum, valorBol, valorOpcion, observacion}
    resultado: null,
    clienteId: null,
    responsableId: null,
    observacionesGenerales: "",
    usuariosEmpresa: [], // el Responsable es un usuario del sistema, no un empleado
    historialEntregas: null, // informativo: fechas de entrega estimadas vs. reales del periodo
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible && this.props.evaluacionId) {
      this.cargarDatos(this.props.evaluacionId);
      this.cargarUsuarios();
    }
    if (prevProps.visible && !this.props.visible) {
      this.setState({
        evaluacion: null,
        respuestas: {},
        resultado: null,
        clienteId: null,
        responsableId: null,
        observacionesGenerales: "",
        historialEntregas: null,
      });
    }
  }

  cargarDatos = (id) => {
    this.setState({ loading: true });
    axios
      .post("evaluacionesProveedor/datosEvaluacion", { id }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const evaluacion = res.data.evaluacion;
          const respuestas = {};
          (evaluacion.respuestas || []).forEach((r) => {
            respuestas[claveRespuesta(r.seccionIndex, r.preguntaIndex)] = r;
          });
          this.setState({
            evaluacion,
            respuestas,
            resultado: evaluacion.resultado,
            clienteId: evaluacion.clienteId?._id || evaluacion.clienteId || null,
            responsableId: evaluacion.responsableId?._id || evaluacion.responsableId || null,
            observacionesGenerales: evaluacion.observacionesGenerales || "",
            historialEntregas: res.data.historialEntregas || null,
          });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar la evaluación." }))
      .finally(() => this.setState({ loading: false }));
  };

  cargarUsuarios = () => {
    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ usuariosEmpresa: res.data });
      })
      .catch(() => {});
  };

  actualizarRespuesta = (seccionIndex, preguntaIndex, cambios) => {
    const clave = claveRespuesta(seccionIndex, preguntaIndex);
    this.setState((prev) => ({
      respuestas: {
        ...prev.respuestas,
        [clave]: { ...prev.respuestas[clave], seccionIndex, preguntaIndex, ...cambios },
      },
    }));
  };

  respuestasComoArray = () => Object.values(this.state.respuestas);

  calcular = () => {
    const { evaluacion } = this.state;
    if (!evaluacion) return;

    this.setState({ guardando: true });
    axios
      .post(
        "evaluacionesProveedor/guardarRespuestas",
        {
          _id: evaluacion._id,
          respuestas: this.respuestasComoArray(),
          clienteId: this.state.clienteId,
          responsableId: this.state.responsableId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ resultado: res.data.resultado });
          notification.success({ message: res.data.message });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al calcular la evaluación." }))
      .finally(() => this.setState({ guardando: false }));
  };

  completar = () => {
    const { evaluacion } = this.state;
    if (!evaluacion) return;

    this.setState({ completando: true });
    axios
      .post(
        "evaluacionesProveedor/completarEvaluacion",
        {
          _id: evaluacion._id,
          respuestas: this.respuestasComoArray(),
          observacionesGenerales: this.state.observacionesGenerales,
          clienteId: this.state.clienteId,
          responsableId: this.state.responsableId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.props.onExito?.();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al completar la evaluación." }))
      .finally(() => this.setState({ completando: false }));
  };

  renderPregunta = (seccionIndex, preguntaIndex, pregunta) => {
    const clave = claveRespuesta(seccionIndex, preguntaIndex);
    const respuesta = this.state.respuestas[clave] || {};
    const soloLectura = this.state.evaluacion?.estadoEvaluacion === "completada";

    return (
      <div
        key={clave}
        style={{ borderBottom: "1px solid #f0f0f0", padding: "10px 0" }}
      >
        <Row gutter={12} align="top">
          <Col span={14}>
            <Text>{pregunta.descripcion}</Text>
            {pregunta.obligatoria && !respuesta.noAplica && (
              <Text type="danger"> *</Text>
            )}
            {pregunta.cuentaParaResultado === false && (
              <Text type="secondary" style={{ fontSize: 11, marginLeft: 6 }}>
                (no cuenta para la evaluación)
              </Text>
            )}
            {pregunta.textoAyuda && (
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {pregunta.textoAyuda}
                </Text>
              </div>
            )}
          </Col>
          <Col span={10}>
            {respuesta.noAplica ? (
              <Tag>No aplica</Tag>
            ) : (
              <>
                {pregunta.tipo === "escala" && (
                  <SelectItem
                    disabled={soloLectura}
                    placeholder="Selecciona"
                    style={{ width: "100%", border: "1px solid #d9d9d9", borderRadius: 4 }}
                    value={respuesta.valorOpcion?.etiqueta}
                    onChange={(etiqueta) => {
                      const opcion = (pregunta.opciones || []).find((o) => o.etiqueta === etiqueta);
                      this.actualizarRespuesta(seccionIndex, preguntaIndex, { valorOpcion: opcion });
                    }}
                  >
                    {(pregunta.opciones || []).map((o) => (
                      <Select.Option key={o.etiqueta} value={o.etiqueta}>
                        {o.etiqueta}
                      </Select.Option>
                    ))}
                  </SelectItem>
                )}
                {pregunta.tipo === "num" && (
                  <>
                    {(pregunta.etiquetaMinimo || pregunta.etiquetaMaximo) && (
                      <Text type="secondary" style={{ fontSize: 11, display: "block", marginBottom: 2 }}>
                        {pregunta.valorMinimo ?? 0}
                        {pregunta.etiquetaMinimo ? ` (${pregunta.etiquetaMinimo})` : ""}
                        {" — "}
                        {pregunta.valorMaximo}
                        {pregunta.etiquetaMaximo ? ` (${pregunta.etiquetaMaximo})` : ""}
                      </Text>
                    )}
                    <InputNumberItem
                      disabled={soloLectura}
                      style={{ width: "100%", border: "1px solid #d9d9d9", borderRadius: 4, padding: "0 4px" }}
                      min={pregunta.valorMinimo ?? 0}
                      max={pregunta.valorMaximo}
                      placeholder={`Máx. ${pregunta.valorMaximo ?? ""}`}
                      value={respuesta.valorNum}
                      onChange={(valor) =>
                        this.actualizarRespuesta(seccionIndex, preguntaIndex, { valorNum: valor })
                      }
                    />
                  </>
                )}
                {pregunta.tipo === "bool" && (
                  <SwitchItem
                    disabled={soloLectura}
                    checked={!!respuesta.valorBol}
                    checkedChildren="Sí"
                    unCheckedChildren="No"
                    onChange={(valor) =>
                      this.actualizarRespuesta(seccionIndex, preguntaIndex, { valorBol: valor })
                    }
                  />
                )}
                {pregunta.tipo === "texto" && (
                  <TextAreaItem
                    disabled={soloLectura}
                    rows={1}
                    value={respuesta.valorTexto}
                    onChange={(e) =>
                      this.actualizarRespuesta(seccionIndex, preguntaIndex, {
                        valorTexto: e.target.value,
                      })
                    }
                  />
                )}
              </>
            )}
            {pregunta.permiteNoAplica && (
              <div style={{ textAlign: "right", marginTop: 4 }}>
                <CheckItem
                  disabled={soloLectura}
                  checked={!!respuesta.noAplica}
                  onChange={(checked) =>
                    this.actualizarRespuesta(seccionIndex, preguntaIndex, { noAplica: checked })
                  }
                >
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    No aplica
                  </Text>
                </CheckItem>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const { visible, onCancel } = this.props;
    const { evaluacion, resultado } = this.state;
    const plantilla = evaluacion?.plantillaId;
    const soloLectura = evaluacion?.estadoEvaluacion === "completada";

    return (
      <ModalItem
        title={
          evaluacion
            ? `Evaluación: ${evaluacion.proveedorNombre} — ${evaluacion.periodo?.etiqueta || ""}`
            : "Evaluación de Proveedor"
        }
        visible={visible}
        onCancel={onCancel}
        spinning={this.state.loading}
        width={800}
      >
        {plantilla && (
          <div>
            {(plantilla.requiereCliente || plantilla.requiereResponsable) && (
              <Row gutter={12} style={{ marginBottom: 16 }}>
                {plantilla.requiereCliente && (
                  <Col span={8}>
                    <Text style={{ display: "block", marginBottom: 4 }}>Cliente</Text>
                    <SelectClientesItem
                      disabled={soloLectura}
                      headersToken={this.props.headersToken}
                      empresaId={this.props.empresaId}
                      value={this.state.clienteId}
                      onChange={(value) => this.setState({ clienteId: value })}
                      style={{ width: "100%", border: "1px solid #d9d9d9", borderRadius: 4 }}
                    />
                  </Col>
                )}
                {plantilla.requiereResponsable && (
                  <Col span={8}>
                    <Text style={{ display: "block", marginBottom: 4 }}>Responsable</Text>
                    <SelectItem
                      disabled={soloLectura}
                      allowClear
                      placeholder="Selecciona un usuario"
                      style={{ width: "100%", border: "1px solid #d9d9d9", borderRadius: 4 }}
                      value={this.state.responsableId ?? undefined}
                      onChange={(value) => this.setState({ responsableId: value ?? null })}
                    >
                      {this.state.usuariosEmpresa.map((u) => (
                        <Select.Option key={u._id} value={u._id}>
                          {`${u.nombre} ${u.apellidoPaterno ?? ""} ${u.apellidoMaterno ?? ""}`.trim()}
                        </Select.Option>
                      ))}
                    </SelectItem>
                  </Col>
                )}
              </Row>
            )}

            {this.state.historialEntregas?.length > 0 && (
              <Card
                size="small"
                style={{ marginBottom: 16, background: "#fafafa" }}
                title="Historial de Entregas del Periodo"
              >
                <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                  Solo informativo — no se guarda como respuesta de esta evaluación.
                </Text>
                <Table
                  size="small"
                  pagination={false}
                  rowKey="ordenDeCompraId"
                  dataSource={this.state.historialEntregas}
                  columns={[
                    { title: "Orden", dataIndex: "folio" },
                    {
                      title: "Fecha Estimada",
                      dataIndex: "fechaEstimada",
                      render: (f) => moment(f).format("DD/MM/YYYY"),
                    },
                    {
                      title: "Fecha Real",
                      dataIndex: "fechaReal",
                      render: (f) => moment(f).format("DD/MM/YYYY"),
                    },
                    {
                      title: "Diferencia",
                      dataIndex: "diasDiferencia",
                      render: (d) => (
                        <Tag color={d > 0 ? "red" : d < 0 ? "green" : "default"}>
                          {d > 0
                            ? `${d} día(s) tarde`
                            : d < 0
                              ? `${Math.abs(d)} día(s) antes`
                              : "A tiempo"}
                        </Tag>
                      ),
                    },
                  ]}
                />
              </Card>
            )}

            {(plantilla.secciones || []).map((seccion, seccionIndex) => (
              <Card
                key={seccionIndex}
                size="small"
                title={seccion.nombre}
                style={{ marginBottom: 12 }}
              >
                {(seccion.preguntas || []).map((pregunta, preguntaIndex) =>
                  this.renderPregunta(seccionIndex, preguntaIndex, pregunta),
                )}
              </Card>
            ))}

            <Divider />

            {resultado && (
              <div
                style={{
                  padding: 16,
                  borderRadius: 8,
                  backgroundColor: "#fafafa",
                  marginBottom: 16,
                }}
              >
                <Row align="middle" gutter={16}>
                  <Col>
                    <Title level={3} style={{ margin: 0 }}>
                      {resultado.calificacionFinal ?? "-"}
                      {resultado.totalPosible != null && (
                        <Text type="secondary" style={{ fontSize: 16, fontWeight: "normal" }}>
                          {" "}
                          / {resultado.totalPosible}
                        </Text>
                      )}
                    </Title>
                  </Col>
                  <Col>
                    <Tag color={resultado.clasificacionColor || "default"} style={{ fontSize: 13 }}>
                      {resultado.clasificacion}
                    </Tag>
                  </Col>
                  <Col flex="auto">
                    {(resultado.porSeccion || []).map((s) => (
                      <Tag key={s.nombre}>
                        {s.nombre}: {s.calificacion ?? "N/A"}
                        {s.totalPosible != null && s.calificacion != null ? ` / ${s.totalPosible}` : ""}
                      </Tag>
                    ))}
                  </Col>
                </Row>
              </div>
            )}

            <Text style={{ display: "block", marginBottom: 4 }}>Observaciones Generales</Text>
            <TextAreaItem
              disabled={soloLectura}
              rows={2}
              value={this.state.observacionesGenerales}
              onChange={(e) => this.setState({ observacionesGenerales: e.target.value })}
            />
          </div>
        )}

        <div style={{ textAlign: "right", marginTop: 20, marginBottom: 2 }}>
          <ButtonItem onClick={onCancel} rojo style={{ marginRight: 8 }}>
            Cerrar
          </ButtonItem>
          {!soloLectura && (
            <>
              <ButtonItem
                onClick={this.calcular}
                loading={this.state.guardando}
                style={{ marginRight: 8 }}
              >
                Calcular / Guardar Borrador
              </ButtonItem>
              <ButtonItem verde onClick={this.completar} loading={this.state.completando}>
                Completar Evaluación
              </ButtonItem>
            </>
          )}
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalLlenarEvaluacion);
